import { SourceBadge } from "@/components/SourceBadge";
import { fmtDate } from "@/lib/permitcheck";

// Consistent titled section card. Optional per-section source badge + count.
export const SectionCard = ({ icon: Icon, title, count, source, retrievedAt, children, testid, lang }) => (
  <section data-testid={testid} className="rounded-xl border border-border bg-card p-6">
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-accent" />}
        <h3 className="font-serif text-lg font-semibold text-foreground">{title}</h3>
      </div>
      {typeof count === "number" && (
        <span className="rounded-full bg-primary/10 px-2 py-0.5 font-mono text-xs font-bold text-primary">
          {count}
        </span>
      )}
      {source && (
        <div className="ml-auto">
          <SourceBadge {...source} retrievedAt={fmtDate(retrievedAt, lang)} />
        </div>
      )}
    </div>
    {children}
  </section>
);
